import Vue from 'vue'
import Vuex from 'vuex'

import mediaStream from './mediaStream'
import room from './room'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    mediaStream,
    room
  },
  getters: {
    isMobile () {
      return !!/Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  }
})
